const Form045TC = {
    stepName: {
        statement: "重要事項",
        notification: "差餉及／或地租調整",
        information: "資料",
        confirmation: "確認",
    },
    errorMsg: {
        needOne: "必須提交3個附件中的任何一個",
        float: {
            rule: "該字段必須是'數字'類型，小數點後最多2位",
        },
        requiredOne: "必須填寫'差餉'或'地租'，或者兩者都可以填寫",
        amount: {
            rule: "請輸入一個有效的款額",
            max: "款額最多為6位數字",
            maxDecimal: "款額必須為最多小數後2位",
            min: "舊款額和新款額之和必須大於0",
        },
        tel: {
            max: "電話號碼必須為最多30位數",
        },
        maxChar: "此項最多只能填寫1000個字",
    },
    serial: ["(a)", "(b)", "(c)", "(d)", "(e)", "(f)", "(g)", "(h)"],
    noteTitle1: "<u>收集個人資料的目的</u>",
    noteTitle3: "<u>可獲轉移資料者</u>",
    noteTitle4: "<u>查閱個人資料</u>",
    notes: [
        "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。",
        "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 <a href='mailto:jokc@edb.gov.hk'>jokc@edb.gov.hk</a>。",
    ],
    notes1: [
        "就<b>差餉及/或地租調整</b>，辦理有關處理、核實及查證的事務；",
        "就上文(a)項所述的處理、核實及查證，辦理有關把<b>個人資料</b>與政府相關政策局／部門資料庫<b>進行核對程序</b>的事務；",
        "為核實／更新教育局的記錄，辦理有關把<b>個人資料</b>與教育局資料庫<b>進行核對程序</b>的事務；",
        "辦理有關<b>培訓及發展</b>的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        "辦理有關處理及審核<b>撥款／補助／津貼</b>申請、發放<b>撥款／補助／津貼</b>，以及審計的事務；",
        "辦理有關編製<b>統計資料、研究材料</b>及<b>政府刊物</b>的事務；以及",
        "辦理有關<b>施行及強制執行規則及規例</b> [包括《教育條例》（香港法例第279章）及其附屬法例（例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》）和《資助則例》）]的事務；及《幼兒服務條例》（香港法例第243章）及其附屬法例 [即《幼兒服務規例》（香港法例第243A章）]的事務",
    ],
    notes3: [
        "政府其他政策局及部門，以用於上文第1段所述的用途；",
        "與本表格相關的學校，以用於上文第1段所述的用途；",
        "你曾就披露個人資料給予訂明同意；以及",
        "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
    ],
    label: {
        note: "個人資料收集聲明",
        statement: "聲明",
        importantNotesTitle: "重要事項",
        importantNotes:
            "沒有「智方便+」戶口的申請人須把已填妥的申請表交回幼稚園及幼兒中心聯合辦事處處理（地址：香港太古城太古灣道14號6樓602室）。請確保已為郵件支付足夠郵資，以免未能送達本局。郵資不足的郵件，一律會由香港郵政處理。",
        certify1: "本人已閱讀、明白及同意上述條款及細則。",
        smart: "本人理解申請人和學校審批人需要擁有「智方便+」帳戶才能處理申請。",
        successfulSubmissionMsgToA:
            "你已成功送出表格。請注意表格尚未提交至教育局。表格正在等待學校審批人審批。",
        headStatement: "本校舍的差餉及／或地租款額已由",
        headStatement1: "起調整，詳情如下：",
        date: "日期",
        period: "期間",
        previousAmount: "舊款額",
        newAmount: "新款額",
        certifiedCopies: "現付上已核證的繳款通知書/租卡的副本，以供查考。",
        demandNotesAttachment: "繳款通知書",
        rentCardAttachment: "租卡",
        othersAttachment: "其他（例如：管理處通知書）",
        certify:
            "請相應調整本校的差餉及／或地租津貼額。本人謹此證實，經教育局核准符合資格申領津貼的校舍，所佔面積並無變動。",
        format: "yyyy MM dd",
        attachment: "繳款通知書／租卡的副本",
        agreement:
            "請相應調整本校的差餉及／或地租津貼額。本人謹此證實，經教育局核准符合資格申領津貼的校舍，所佔面積並無變動。",
        specify: "請列明",
        specification: "列明",
        supervisorName: "校監姓名",
        schoolName: "學校名稱",
        contactPerson: "聯絡人姓名",
        telNo: "電話號碼",
        certOptions: {
            demandNotesAttachment: "繳款通知書",
            rentCardAttachment: "租卡",
            othersAttachment: "其他（例如：管理處通知書）",
        },
        infor: "資料",
    },
    amountValue: {
        Rates: "差餉：",
        "Government Rent": "地租：",
    },
    periodRValue: {
        Quarter: "每季",
        Month: "每月",
        NA: "不適用",
    },
    periodGValue: {
        Quarter: "每季",
        Month: "每月",
        "Half year": "每半年",
        NA: "不適用",
    },
};
export default Form045TC;
